import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { CreateGroupForm } from '../CreateGroupForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function CreateGroupListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`สร้างกลุ่มผู้ใช้งาน`}
					description="สร้างกลุ่มผู้ใช้งาน"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			<CreateGroupForm />
		</div>
	)
}
